module.exports = __webpack_public_path__ + "img/9ccca2209d9eca2b2724ba11163d4097.svg";